import React, { useState } from "react";
export default (props) => {
  let type = "";
  let title = "";
  switch (props.variant) {
    case "active":
      type = "success";
      title = "فعال";
      break;
    case "deactive":
      type = "danger";
      title = "غیرفعال";
      break;
    case "reject":
      type = "danger";
      title = "ردشده";
      break;
    case "reject":
      type = "danger";
      title = "ردشده";
      break;
    case "waiting":
      type = "warning";
      title = "در انتظار تایید";
      break;
    case "expired":
      type = "danger";
      title = "پایان یافته";
      break;
    case "register":
      type = "warning";
      title = "در حال ثبت نام";
      break;

    case "started":
      type = "success";
      title = "در حال برگزاری";
      break;

    case "payed":
      type = "success";
      title = "پرداخت شده";
      break;

    case "unpaid":
      type = "info";
      title = "پرداخت نشده";
      break;
    
      case "cancelled":
      type = "danger";
      title = "کنسل شده";
      break;

    case "canceled":
      type = "danger";
      title = "کنسل شده";
      break;
  }
  return <div className={`text text-${type}`}>{title}</div>;
};
